import { render, staticRenderFns } from "./BibliographyRealInfoSimple.vue?vue&type=template&id=f5f35008&"
import script from "./BibliographyRealInfoSimple.vue?vue&type=script&lang=ts&"
export * from "./BibliographyRealInfoSimple.vue?vue&type=script&lang=ts&"
import style0 from "./BibliographyRealInfoSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRow,VTooltip})
